var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 28,
    viewBox: "0 0 19 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_46360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7298 27.9993C7.32124 27.9993 9.42444 25.9087 9.42444 23.3327V18.666H4.7298C2.13836 18.666 0.0351562 20.7567 0.0351562 23.3327C0.0351562 25.9087 2.13836 27.9993 4.7298 27.9993Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0351562 14.0007C0.0351562 11.4247 2.13836 9.33398 4.7298 9.33398H9.42444V18.6673H4.7298C2.13836 18.6673 0.0351562 16.5767 0.0351562 14.0007Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0351562 4.66667C0.0351562 2.09067 2.13836 0 4.7298 0H9.42444V9.33333H4.7298C2.13836 9.33333 0.0351562 7.24267 0.0351562 4.66667Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42383 0H14.1185C16.7099 0 18.8131 2.09067 18.8131 4.66667C18.8131 7.24267 16.7099 9.33333 14.1185 9.33333H9.42383V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8131 14.0007C18.8131 16.5767 16.7099 18.6673 14.1185 18.6673C11.527 18.6673 9.42383 16.5767 9.42383 14.0007C9.42383 11.4247 11.527 9.33398 14.1185 9.33398C16.7099 9.33398 18.8131 11.4247 18.8131 14.0007Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_46360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.7786,
    height: 28,
    fill: "white",
    transform: "translate(0.0351562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosFigma);
export default __webpack_public_path__ + "static/media/logos_figma.aa04fc8dd173696c9c01d0437358011c.svg";
export { ForwardRef as ReactComponent };